import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { createHttpLink } from 'apollo-link-http';
import Bugsnag from 'common/utils/Bugsnag';
import Cookies from 'cookies-js';
import { print } from 'graphql/language/printer';

const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData: {
        __schema: {
            types: [
                {
                    kind: 'UNION',
                    name: 'StructuredBriefFields',
                    possibleTypes: [
                        {
                            name: 'ProjectBriefFields',
                        },
                        {
                            name: 'SquarespaceApiBriefFields',
                        },
                        {
                            name: 'SquarespaceBriefFields',
                        },
                        {
                            name: 'PreziBriefFields',
                        },
                    ],
                },
            ],
        },
    },
});

const errorLink = onError(({ graphQLErrors, operation }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(error => {
            Bugsnag.notify('GraphQL error: ' + error.message, {
                metaData: {
                    operationName: operation.operationName,
                    query: print(operation.query),
                    path: error.path,
                },
            });
        });
    }
});

const httpLink = createHttpLink({
    uri: '/create/graphql',
    credentials: 'same-origin',
    headers: {
        'X-Csrf-Token': Cookies.get('_99csrf'),
    },
});

const client = new ApolloClient({
    link: ApolloLink.from([errorLink, httpLink]),
    cache: new InMemoryCache({ fragmentMatcher }),
});

export default client;
